import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const refreshAttempted = useRef(false);
  const redirectTimer = useRef(null);

  useEffect(() => {
    // Only attempt refresh once
    if (refreshAttempted.current) {
      return;
    }

    const initPage = async () => {
      try {
        refreshAttempted.current = true;
        console.log("Refreshing user data...");
        await refreshUser();
        console.log("User data refreshed");

        // Clear any existing timer
        if (redirectTimer.current) {
          clearTimeout(redirectTimer.current);
        }
        // Set new timer for redirection
        redirectTimer.current = setTimeout(() => {
          console.log("Navigating to home...");
          navigate("/load-search", { replace: true });
        }, 3000);
      } catch (error) {
        console.error("Error refreshing user data:", error);
        // Still redirect even if refresh fails
        redirectTimer.current = setTimeout(() => {
          navigate("/load-search", { replace: true });
        }, 3000);
      }
    };

    initPage();

    // Cleanup function
    return () => {
      if (redirectTimer.current) {
        clearTimeout(redirectTimer.current);
      }
    };
  }, [navigate, refreshUser]); // Remove navigate and refreshUser from deps to prevent re-runs

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          background: "var(--background)",
          padding: "40px",
          borderRadius: "16px",
          boxShadow: "var(--shadow)",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <i
          className="fas fa-check-circle"
          style={{
            color: "var(--success)",
            fontSize: "64px",
            marginBottom: "24px",
          }}
        ></i>

        <h1
          style={{
            fontSize: "32px",
            color: "var(--text)",
            marginBottom: "16px",
          }}
        >
          Subscription Successful!
        </h1>

        <p
          style={{
            fontSize: "18px",
            color: "var(--text)",
            marginBottom: "24px",
          }}
        >
          Thank you for subscribing! Your account has been upgraded and you now
          have access to all premium features.
        </p>

        <p
          style={{
            fontSize: "16px",
            color: "var(--muted)",
          }}
        >
          Redirecting to the dashboard in a few seconds...
        </p>
      </div>
    </div>
  );
}
